import {Component} from "react";
import {Button, Card, Col, Form, FormText, Row, Table} from "react-bootstrap";
import {Redirect} from "react-router-dom";
import {Home} from "../../../config/Routes";
import {toast} from "react-toastify";
import "../../../assets/scss/SetPassword.scss"
import PasswordDeductions from "./PasswordDeductions";
import PasswordScoreAdditions from "./PasswordScoreAdditions";
import CalculatePasswordScore, {DefaultPasswordScore, PasswordScore} from "../CalculatePasswordScore";
import {FaEye, FaEyeSlash} from "react-icons/all";

export interface NewPasswordProps{
    submitPassword: (password: string)=> void
}
interface NewPasswordState{
    password: string
    goHome: boolean
    score: PasswordScore
    showPasswordText: boolean
}
export default class NewPassword extends Component<NewPasswordProps, NewPasswordState> {

    state: NewPasswordState ={
        goHome: false,
        password: '',
        showPasswordText: false,
        score: DefaultPasswordScore
    }
    passwordAppearsValid = (): boolean => {
        return true;
    }
    submitPassword = ()=> {
        if(this.passwordAppearsValid()){
            this.props.submitPassword(this.state.password);
        }else{
            toast.error("Password strength does not meet minimum strength requirements!")
        }
    }
    changePassword = (password: string): void => {
        const score =  CalculatePasswordScore(password);
        this.setState({password, score});
    }

    render() {
        return <div className="col d-flex justify-content-center">
            {this.state.goHome && <Redirect to={Home} /> }
            <Card style={{ width: '120rem' }}>
                <Card.Header>Enter New Password</Card.Header>
                <Form onSubmit={(e)=>{e.preventDefault();this.submitPassword()}}>
                    <Card.Body>
                        <Row>
                            <Col md={6}>
                                <PasswordScoreAdditions score={this.state.score} />
                            </Col >
                            <Col md={6}>
                                <PasswordDeductions score={this.state.score} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={1}>
                                {this.state.showPasswordText  && <FaEye size={32} onClick={()=>{this.setState({showPasswordText: false})}}/> }
                                {!this.state.showPasswordText  && <FaEyeSlash size={32} onClick={()=>{this.setState({showPasswordText: true})}}/>}
                            </Col>
                            <Col md={11}>
                                <FormText>
                                    <Form.Group className="mb-3" controlId="frmBasicPassword">
                                        <Form.Control autoFocus={true} value={this.state.password}
                                                      autoComplete="off"
                                                      onChange={(e) => {this.changePassword(e.target.value)}}
                                                      type={this.state.showPasswordText ?'text' :'password'} placeholder="New Password" />
                                    </Form.Group>
                                </FormText>
                            </Col>
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <Button className="m-2" variant='outline-secondary' onClick={() => {this.setState({goHome: true})}}>
                            Return Home
                        </Button>
                        <Button type="submit" className="float-right" variant='primary'>
                            Change Password
                        </Button>
                    </Card.Footer>
                </Form>
            </Card>
        </div>
    }
}
